import $ from "jquery";
import EnteteBonEtFacture from '@/views/en-tete-bon-facture';

export default {
    name: 'resultat-patient',
    components: {
        EnteteBonEtFacture
    },
    props: {
        results: Object,
        evolution_id: Number,
        view_result_loading: Boolean
    },
    data() {
        return {
            can_print: false,
            is_printing: false
        }
    },

    computed: {
        modalId() {
            if (this.evolution_id) {
                return `view-analysis-modal-${this.evolution_id}`;
            }

            return 'view-analysis-modal';
        },

        headerRowLength() {
            let maxLength = 0;
            if (this.results && this.results.data !== null) {
                for (const row of this.results.data) {
                    maxLength = Math.max(maxLength, row.cells.length);
                }
            }
            return maxLength;
        },

        modele_analyse() {
            return this.$store.getters.current_modele_analyse;
        }
    },

    mounted() {
        
    },

    methods: {
        visibleCells(row) {
            return row && Array.isArray(row.cells) ? row.cells.filter(cell => !cell.merged) : [];
        },
        removeParagraph(text) {
            return text == null ? text : text.replace(/<p>/g, '').replace(/<\/p>/g, '');
        },

        async confirmDeleteResults() {
            this.isLoading = true;
            
            const response = await this.$store.dispatch('deleteResultatsAnalyse', this.results.id);

            if (response.status === 200) {
                this.isLoading = false;

                $('#resultsDeleteConfirmModal').modal('hide');
                $('#'+this.modalId).modal('hide');
                
                this.successToast('Resultats supprimés avec succès');

                this.$emit('onRefresh');
            } else {
                this.errorToast('Une erreur est survenue!');
            }
        },
        
        closeModal(event) {
            event.preventDefault();
            event.stopPropagation();

            $('#resultsDeleteConfirmModal').modal('hide');
        },

        generateFilename(patientFullname) {
            const timestamp = new Date().getTime();
            const sanitizedFullname = patientFullname.replace(/ /g, '_');
            return `Resultats analyse_${sanitizedFullname}_${timestamp}.pdf`;
        },
        
        // printResultatPatient() {
        //     this.$emit('emitPrint', this.results)
        // },
    }
}
